import { es } from 'yup-locales'
import { setLocale } from 'yup'
setLocale(es)
